/**
 * URLs de checkout directo de Stock Digital.
 * Apuntan directo al checkout, sin pasar por la página de la tienda.
 */
export const CHECKOUT_URLS = {
  hogarNatural:
    'https://www.stockdigital.shop/checkouts/cn/hWNCq8CH0z607s5BNsPfHsPq/es-ar?_r=AQABln35w9BfwJUyEtmeiUHFTU6h9k-SOLlMEL_JpJo0IFs&cart_link_id=WjYiJNvy&preview_theme_id=140123340859',
  superPack:
    'https://www.stockdigital.shop/checkouts/cn/hWNCjQHMU9rVATNt550xnQyg/es-ar?_r=AQABZq_eFVVVzsUaqq90kJlDISy9ZoYTEtqpOsFjN6vy',
} as const
